export default __webpack_public_path__ + "static/media/03-Tiktok.f0441f5e.png";